import React from "react";

import modStyl from './block-a.module.scss'
import Cell from "../cell";
import { ChartDataResult } from "../../../../../../../services/data/dashboard";
import LineChart from "../line-chart";

type Props = {
  dataSource: ChartDataResult['formDataStatistics']
}

const BlockH: React.FC<Props> = ({ dataSource })=> {
  return (
    <div className={modStyl.a}>
      <div className={modStyl.a2}>
        <LineChart name="患者入组率" data={[
          {value: dataSource.formNewTherapy, name: '新辅助治疗期4周无数据'},
          {value: dataSource.formTherapy, name: '辅助治疗期4周无数据'},
          {value: dataSource.formOperating, name: '术后6周无数据'},
          {value: dataSource.therapyNotOperating, name: '存在辅助治疗数据无手术数据'},
        ]}/>
      </div>
    </div>
  )
}

export default BlockH